import { render, staticRenderFns } from "./UserNotificationComponent.vue?vue&type=template&id=05555511&"
import script from "./UserNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./UserNotificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports